export default "__VITE_ASSET__BVeYF5Bh__"